<template>
    <div class="main-wrapper">
        <layout-header />

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2">
                                <customer-sidebar v-if="currentUser.role == 'player'"></customer-sidebar>
                                <vendor-sidebar v-else></vendor-sidebar>
                            </div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Changer Mot de Passe</h2>
                        </div>
                        <form @submit.prevent="changePassword" style="max-width: 480px">
                            <div class="form-group card-label mb-3">
                                <label>Mot de passe actuel</label>
                                <input 
                                    type="password" 
                                    class="form-control" 
                                    :class="{ 'is-invalid': fieldErrors.current_password }"
                                    v-model="passwordData.current_password"
                                    @input="fieldErrors.current_password = ''"
                                    required/>
                                <small class="text-muted d-block" v-if="passwordData.current_password && !fieldErrors.current_password">Entrez votre mot de passe actuel</small>
                                <small class="text-danger d-block" v-if="fieldErrors.current_password">{{ fieldErrors.current_password }}</small>
                            </div>

                            <div class="form-group card-label mb-3">
                                <label>Nouveau mot de passe</label>
                                <input 
                                    type="password" 
                                    class="form-control"
                                    :class="{ 'is-invalid': fieldErrors.new_password }"
                                    v-model="passwordData.new_password" 
                                    @input="updatePasswordStrength" 
                                    required/>
                                <small class="text-muted d-block">Minimum 8 caractères avec majuscules, minuscules, chiffres et caractères spéciaux</small>
                                <small class="text-danger d-block" v-if="fieldErrors.new_password">{{ fieldErrors.new_password }}</small>
                                
                                <div class="mt-2" v-if="passwordData.new_password && !fieldErrors.new_password">
                                    <div class="progress" style="height: 5px;">
                                        <div class="progress-bar" :class="passwordStrengthClass" role="progressbar" 
                                            :style="{ width: passwordStrength + '%' }" :aria-valuenow="passwordStrength" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <small :class="passwordStrengthTextClass">{{ passwordStrengthText }}</small>
                                </div>

                                <ul class="list-unstyled mt-2" v-if="passwordData.new_password && !fieldErrors.new_password">
                                    <li :class="passwordRequirements.length ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.length ? 'check_circle' : 'cancel' }}</i>
                                        Minimum 8 caractères
                                    </li>
                                    <li :class="passwordRequirements.uppercase ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.uppercase ? 'check_circle' : 'cancel' }}</i>
                                        Au moins une majuscule
                                    </li>
                                    <li :class="passwordRequirements.lowercase ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.lowercase ? 'check_circle' : 'cancel' }}</i>
                                        Au moins une minuscule
                                    </li>
                                    <li :class="passwordRequirements.number ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.number ? 'check_circle' : 'cancel' }}</i>
                                        Au moins un chiffre
                                    </li>
                                    <li :class="passwordRequirements.special ? 'text-success' : 'text-danger'">
                                        <i class="material-symbols-outlined text-sm">{{ passwordRequirements.special ? 'check_circle' : 'cancel' }}</i>
                                        Au moins un caractère spécial (@, #, $, !,...)
                                    </li>
                                </ul>
                            </div>

                            <div class="form-group card-label mb-3">
                                <label>Confirmer le nouveau mot de passe</label>
                                <input 
                                    type="password" 
                                    class="form-control"
                                    :class="{ 'is-invalid': fieldErrors.confirm_password }"
                                    v-model="passwordData.confirm_password"
                                    @input="fieldErrors.confirm_password = ''"
                                    required/>
                                <small v-if="passwordData.confirm_password && passwordData.new_password !== passwordData.confirm_password && !fieldErrors.confirm_password" class="text-danger d-block">
                                    Les mots de passe ne correspondent pas
                                </small>
                                <small class="text-danger d-block" v-if="fieldErrors.confirm_password">{{ fieldErrors.confirm_password }}</small>
                            </div>

                            <div class="submit-section d-flex gap-3">
                                <button type="submit" class="btn btn-primary btn-rounded text-sm mr-2" :disabled="!isFormValid()">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Changer le mot de passe</label>
                                </button>
                                <router-link to="/my/profile" class="btn btn-secondary btn-rounded text-sm">
                                    Annuler
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <layout-footer />
    </div>
</template>

<script>
import { api } from "@/store";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";

export default {
    components: {
        "vendor-sidebar": VendorSidebar,
        "customer-sidebar": CustomerSidebar,
    },
    data() {
        return {
            passwordData: {
                current_password: '',
                new_password: '',
                confirm_password: '',
            },
            passwordRequirements: {
                length: false,
                uppercase: false,
                lowercase: false,
                number: false,
                special: false,
            },
            passwordStrength: 0,
            fieldErrors: {
                current_password: '',
                new_password: '',
                confirm_password: '',
            },
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        passwordStrengthText() {
            if (this.passwordStrength < 20) return 'Très faible';
            if (this.passwordStrength < 40) return 'Faible';
            if (this.passwordStrength < 60) return 'Moyen';
            if (this.passwordStrength < 80) return 'Bon';
            return 'Très fort';
        },
        passwordStrengthClass() {
            if (this.passwordStrength < 20) return 'bg-danger';
            if (this.passwordStrength < 40) return 'bg-warning';
            if (this.passwordStrength < 60) return 'bg-info';
            if (this.passwordStrength < 80) return 'bg-success';
            return 'bg-success';
        },
        passwordStrengthTextClass() {
            if (this.passwordStrength < 20) return 'text-danger';
            if (this.passwordStrength < 40) return 'text-warning';
            if (this.passwordStrength < 60) return 'text-info';
            if (this.passwordStrength < 80) return 'text-success';
            return 'text-success';
        },
    },
    methods: {
        updatePasswordStrength() {
            const password = this.passwordData.new_password;
            this.fieldErrors.new_password = ''; // Clear error when user types
            
            this.passwordRequirements.length = password.length >= 8;
            this.passwordRequirements.uppercase = /[A-Z]/.test(password);
            this.passwordRequirements.lowercase = /[a-z]/.test(password);
            this.passwordRequirements.number = /[0-9]/.test(password);
            this.passwordRequirements.special = /[@#$!%*?&^()_+=\-\[\]{};':"\\|,.<>\/?]/.test(password);

            let strength = 0;
            if (this.passwordRequirements.length) strength += 20;
            if (this.passwordRequirements.uppercase) strength += 20;
            if (this.passwordRequirements.lowercase) strength += 20;
            if (this.passwordRequirements.number) strength += 20;
            if (this.passwordRequirements.special) strength += 20;

            this.passwordStrength = strength;
        },
        isFormValid() {
            return (
                this.passwordData.current_password &&
                this.passwordData.new_password &&
                this.passwordData.confirm_password &&
                this.passwordData.new_password === this.passwordData.confirm_password &&
                this.passwordStrength === 100 &&
                !this.fieldErrors.current_password &&
                !this.fieldErrors.new_password &&
                !this.fieldErrors.confirm_password
            );
        },
        async changePassword() {
            this.fieldErrors = {
                current_password: '',
                new_password: '',
                confirm_password: '',
            };

            if (!this.passwordData.current_password) {
                this.fieldErrors.current_password = 'Le mot de passe actuel est requis.';
                return;
            }
            if (!this.passwordData.new_password) {
                this.fieldErrors.new_password = 'Le nouveau mot de passe est requis.';
                return;
            }
            if (!this.passwordData.confirm_password) {
                this.fieldErrors.confirm_password = 'La confirmation du mot de passe est requise.';
                return;
            }
            if (this.passwordData.new_password !== this.passwordData.confirm_password) {
                this.fieldErrors.confirm_password = 'Les mots de passe ne correspondent pas.';
                return;
            }
            if (this.passwordStrength !== 100) {
                this.fieldErrors.new_password = 'Le mot de passe ne respecte pas tous les critères de sécurité.';
                return;
            }

            const button = document.querySelector('.submit-section button[type="submit"]');
            const spinner = button.querySelector('.spinner-border');
            button.setAttribute('disabled', 'disabled');
            spinner.classList.remove('d-none');

            try {
                const response = await api.put('/private/auth/change-password', {
                    current_password: this.passwordData.current_password,
                    new_password: this.passwordData.new_password,
                });
                if (response.data.error_type === 'validation') {
                    const field = response.data.field;
                    if (field && this.fieldErrors.hasOwnProperty(field)) {
                        this.fieldErrors[field] = response.data.detail;
                    }
                    button.removeAttribute('disabled');
                    spinner.classList.add('d-none');
                    return;
                }
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'check_circle',
                    icon_color: 'text-success',
                    title: 'Succès',
                    detail: response.data.message || 'Votre mot de passe a été modifié avec succès.'
                });

                this.passwordData = {
                    current_password: '',
                    new_password: '',
                    confirm_password: '',
                };
                this.passwordStrength = 0;
            } catch (error) {
                const errorDetail = error.response?.data?.detail || 'Une erreur est survenue lors du changement du mot de passe.';
                
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: errorDetail
                });
            } finally {
                button.removeAttribute('disabled');
                spinner.classList.add('d-none');
            }
        },
    },
};
</script>

<style scoped>
.list-unstyled li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
}

.list-unstyled i {
    min-width: 20px;
}
</style>
